import { render, staticRenderFns } from "./UserStripeEvents.vue?vue&type=template&id=ae87f7e8&scoped=true"
import script from "./UserStripeEvents.vue?vue&type=script&lang=js"
export * from "./UserStripeEvents.vue?vue&type=script&lang=js"
import style0 from "./UserStripeEvents.vue?vue&type=style&index=0&id=ae87f7e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae87f7e8",
  null
  
)

export default component.exports